import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Create axios instance with default config
const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 errors
api.interceptors.response.use(
  (response) => {
    // ====== DEBUG: Log all product responses ======
    if (response.config?.url?.includes('/products/')) {
      console.log('[DEBUG API] Response interceptor for:', response.config.url);
      console.log('[DEBUG API] download_fiche_enabled in response.data:', response.data?.download_fiche_enabled);
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;

/**
 * Extraire les produits d'une réponse API (compatible ancien format array ET nouveau format paginé)
 * Usage: const { products, total } = extractProducts(response.data)
 */
export function extractProducts(data) {
  if (Array.isArray(data)) {
    return { products: data, total: data.length, offset: 0, limit: data.length };
  }
  if (data && Array.isArray(data.products)) {
    return { products: data.products, total: data.total || data.products.length, offset: data.offset || 0, limit: data.limit || data.products.length };
  }
  return { products: [], total: 0, offset: 0, limit: 0 };
}
